import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  useToast,
} from '@ais-ui/ui-core';
import React from 'react';
import { CustomizePopover } from './CustomizePopover';
import { multiShapeReportMiscellaneous } from '../reportsTypes';
import {
  ParsedReportParams,
  useMultiShapeReconfigure,
} from '@ais-ui/websockets';
import { useFetchOverlayData } from '../useMapReportOverlay';

interface CustomizeMultiShapeProps {
  report: ParsedReportParams;
  className?: string;
}

export const CustomizeMultiShape = ({
  report,
  className,
}: CustomizeMultiShapeProps) => {
  const fetchOverlayData = useFetchOverlayData();
  const { mutate } = useMultiShapeReconfigure(fetchOverlayData);

  const [outputType, setOutputType] = React.useState(report.params.PAC);
  const [statisticGrouping, setStatisticGrouping] = React.useState(
    report.params.STG
  );
  const [interval, setInterval] = React.useState(report.params.PI);

  const { toast } = useToast();

  const onApply = () => {
    mutate(
      {
        jobId: report.info?.['Job ID'] as string,
        outputType: outputType,
        statisticGrouping: statisticGrouping,
        interval: interval,
      },
      {
        onSuccess: () => {
          toast({
            title: 'Success!',
            description: 'Customized multi shape report successfully',
          });
        },
        onError: () => {
          toast({
            title: 'Error!',
            description: 'Error customizing multi shape report',
            variant: 'destructive',
          });
        },
      }
    );
  };

  return (
    <CustomizePopover>
      <form className="grid grid-cols-2 gap-8 p-2 w-96">
        <div className="space-y-2">
          <Label htmlFor="output-type">Output type</Label>
          <Select value={outputType} onValueChange={setOutputType}>
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select an output type" />
            </SelectTrigger>
            <SelectContent>
              {multiShapeReportMiscellaneous?.outputType?.options?.map(
                (outputTypeOption) => (
                  <SelectItem
                    key={outputTypeOption.value}
                    value={outputTypeOption.value}
                  >
                    {outputTypeOption.label}
                  </SelectItem>
                )
              )}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="statistic-grouping">Statistic grouping</Label>
          <Select
            value={statisticGrouping}
            onValueChange={setStatisticGrouping}
          >
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select a statistic grouping" />
            </SelectTrigger>
            <SelectContent>
              {multiShapeReportMiscellaneous?.statisticGrouping?.options?.map(
                (statisticGroupingOption) => (
                  <SelectItem
                    key={statisticGroupingOption.value}
                    value={statisticGroupingOption.value}
                  >
                    {statisticGroupingOption.label}
                  </SelectItem>
                )
              )}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="interval">Interval</Label>
          <Select value={interval} onValueChange={setInterval}>
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Select an interval" />
            </SelectTrigger>
            <SelectContent>
              {multiShapeReportMiscellaneous?.interval?.options?.map(
                (intervalOption) => (
                  <SelectItem
                    key={intervalOption.value}
                    value={intervalOption.value}
                  >
                    {intervalOption.label}
                  </SelectItem>
                )
              )}
            </SelectContent>
          </Select>
        </div>
      </form>
      <div className="pt-6 flex justify-end">
        <Button onClick={onApply}>Apply</Button>
      </div>
    </CustomizePopover>
  );
};
